import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-index-1000 rounded-lg"
}
const _hoisted_2 = { class: "text-center p-4 bg-white bg-opacity-90 rounded shadow-md" }
const _hoisted_3 = { class: "material-icons text-amber-500 text-4xl mb-2" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.icon), 1),
          _createElementVNode("p", {
            class: "text-gray-800 font-medium",
            innerHTML: _ctx.message
          }, null, 8, _hoisted_4)
        ])
      ]))
    : _createCommentVNode("", true)
}